import { useState } from "react";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Gallery } from "@/components/Gallery";
import { Marquee } from "@/components/Marquee";
import { Chapters } from "@/components/Chapters";
import { Scents } from "@/components/Scents";
import { Reviews } from "@/components/Reviews";
import { OrderCalculator } from "@/components/OrderCalculator";
import { Footer } from "@/components/Footer";
import { StickyMobileBar } from "@/components/StickyMobileBar";
import { SCENTS } from "@/config";

const GRAIN =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='120' height='120' filter='url(%23n)' opacity='0.6'/></svg>";

const Grain = () => (
  <div
    aria-hidden
    className="pointer-events-none fixed inset-0 z-[60] opacity-[0.05] mix-blend-multiply"
    style={{ backgroundImage: `url("${GRAIN}")` }}
  />
);

export default function App() {
  useLenis();
  const [scent, setScent] = useState(SCENTS[0]);

  return (
    <div className="bg-brandCream text-brandDarkSlate font-sans antialiased overflow-x-clip pb-24 md:pb-0">
      <Grain />
      <Header />
      <main>
        <Hero />
        <Gallery />
        <Marquee />
        <Chapters />
        <Scents selected={scent} onSelect={setScent} />
        <Reviews />
        <OrderCalculator scent={scent} onScentChange={setScent} />
      </main>
      <Footer />
      <StickyMobileBar />
    </div>
  );
}
